import { createSlice } from "@reduxjs/toolkit";

const savedMode = localStorage.getItem("darkMode") === "true";

const themeSlice = createSlice({
    name: "theme",
    initialState: { darkMode: savedMode },
    reducers: {
        toggleDarkMode: (state) => {
            state.darkMode = !state.darkMode;
            localStorage.setItem("darkMode", state.darkMode);
        },
        setDarkMode: (state, action) => {
            state.darkMode = action.payload;
            localStorage.setItem("darkMode", action.payload);
        },
    },
});

export const { toggleDarkMode, setDarkMode } = themeSlice.actions;
export default themeSlice.reducer;
